(function () {
  if (window.__giftTierInit) return;
  window.__giftTierInit = true;

  let inFlight = false;

  function getConfig() {
    const bar = document.querySelector('shipping-bar.progress-bar--two-tier[data-gift-variant]');
    if (!bar) return null;
    const variantId = parseInt(bar.dataset.giftVariant, 10);
    const threshold = parseInt(bar.dataset.giftThreshold, 10);
    if (!variantId || !threshold) return null;
    return { variantId, threshold };
  }

  async function reconcile() {
    if (inFlight) return;
    const cfg = getConfig();
    if (!cfg) return;

    inFlight = true;
    try {
      const cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(r => r.json());
      const giftLines = cart.items.filter(i => i.variant_id === cfg.variantId);
      const giftLine = giftLines[0];
      const giftQty = giftLines.reduce((s, i) => s + i.quantity, 0);

      if (cart.total_price >= cfg.threshold) {
        if (!giftLine) {
          await fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: cfg.variantId, quantity: 1 }] })
          });
          requestRefresh();
        } else if (giftQty > 1) {
          await fetch('/cart/change.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: giftLine.key, quantity: 1 })
          });
          requestRefresh();
        }
      } else if (giftLine) {
        await fetch('/cart/change.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: giftLine.key, quantity: 0 })
        });
        requestRefresh();
      }
    } catch (e) {
      console.warn('[gift-tier] reconcile failed', e);
    } finally {
      inFlight = false;
    }
  }

  async function requestRefresh() {
    const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const targets = [];

    const drawerBody = document.getElementById('CartDrawer-Body');
    const drawerSummary = document.getElementById('CartDrawer-Summary');
    if (drawerBody || drawerSummary) {
      targets.push({ section: 'cart-drawer', selectors: [
        ['#CartDrawer-Body', '#CartDrawer-Body'],
        ['#CartDrawer-Summary', '#CartDrawer-Summary']
      ] });
    }

    const mainCartEl = document.getElementById('main-cart-items');
    if (mainCartEl && mainCartEl.dataset.id) {
      targets.push({ section: mainCartEl.dataset.id, selectors: [
        ['cart-items', '#shopify-section-' + mainCartEl.dataset.id + ' cart-items']
      ] });
    }

    for (const t of targets) {
      try {
        const html = await fetch(root + '?sections=' + encodeURIComponent(t.section), { credentials: 'same-origin' })
          .then(r => r.json())
          .then(s => s[t.section]);
        if (!html) continue;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        t.selectors.forEach(([sel, curSel]) => {
          const fresh = doc.querySelector(sel);
          const cur = document.querySelector(curSel);
          if (fresh && cur) cur.innerHTML = fresh.innerHTML;
        });
      } catch (e) {
        console.warn('[gift-tier] section refresh failed', e);
      }
    }
  }

  document.addEventListener('cart:updated', () => {
    setTimeout(reconcile, 50);
  });

  document.addEventListener('DOMContentLoaded', () => {
    setTimeout(reconcile, 400);
  });
})();
